export default "__VITE_ASSET__CD7yMLp7__"